import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox--sprite",
  "use": "checkbox--sprite-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol viewBox=\"0 0 18 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkbox--sprite\">\n<path d=\"M16 2.43945V16.4395H2V2.43945H16ZM16 0.439453H2C0.9 0.439453 0 1.33945 0 2.43945V16.4395C0 17.5395 0.9 18.4395 2 18.4395H16C17.1 18.4395 18 17.5395 18 16.4395V2.43945C18 1.33945 17.1 0.439453 16 0.439453Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol